export const getOrderList = state => state.ordersComplete.numbers.map(number => state.orders[number]);

export const completedChatNotifications = state => state.clientChatNotifications.notifications.filter(item => item.count > 0 && state.ordersComplete.numbers.includes(item.number));

export const getUnreadCompetedOrdersMessages = state => state.ordersComplete.unreadOrderMessages > 0;
